import { Injector } from "@angular/core";
import moment from 'moment';
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { DateRange } from "./dateRange";

class Range {
    public begin: string;
    public end: string;

    constructor(begin: string, end: string) {
        this.begin = begin;
        this.end = end;
    }
}

export abstract class OccupationalRiskPreventionDirectKpiService<T> extends KpiService<T> {
    constructor(injector: Injector) {
        super(injector);
    }

    protected getDateRange(range: DateRange): Range {
        switch (range) {
            case DateRange.Inmediate: return this.getDayDates();
            case DateRange.CurrentWeek: return this.getWeekDates();
            default: throw new Error("Invalid date range");
        }
    }

    private getDayDates(): Range {
        let begin = moment();
        let formattedDate = this.formatDate(begin);
        return new Range(formattedDate, formattedDate);
    }

    private formatDate(d: moment.Moment): string {
        return "{0}{1}{2}".format(String(d.year()).padStart(4, "0"), String(d.month() + 1).padStart(2, "0"), String(d.date()).padStart(2, "0"));
    }

    private getWeekDates(): Range {
        let begin = moment().isoWeekday(1);
        let end = moment().isoWeekday(7);
        return new Range(this.formatDate(begin), this.formatDate(end));
    }
}
